module.exports = __webpack_public_path__ + "img/标题文字_新闻资讯.927b7764.svg";